import React from 'react';
import { useSettings } from '@/context/SettingsContext';

const SubscriptionCertificate = React.forwardRef(({ subscription, member, plan, company }, ref) => {
  const { formatCurrency, formatDate } = useSettings();

  return (
    <div ref={ref} style={{ display: 'none' }}>
      <div className="receipt-a4" style={{
        width: '210mm',
        height: '297mm',
        padding: '16mm',
        margin: '0 auto',
        backgroundColor: 'white',
        fontFamily: 'Arial, sans-serif',
        border: '6px solid #84cc16',
        boxSizing: 'border-box'
      }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '28px' }}>
          {company?.logo_url && (
            <img 
              src={`${process.env.REACT_APP_BACKEND_URL}${company.logo_url}`}
              alt="Company Logo" 
              crossOrigin="anonymous"
              style={{ maxHeight: '70px', maxWidth: '200px', margin: '0 auto 12px', display: 'block' }}
            />
          )}
          <h1 style={{ margin: '0', fontSize: '34px', fontWeight: 'bold', color: '#18181b' }}>{company?.name || 'Gym'}</h1>
          <p style={{ margin: '6px 0', fontSize: '13px', color: '#71717a' }}>{company?.address || ''}</p>
        </div>

        {/* Certificate Title */}
        <div style={{ textAlign: 'center', marginBottom: '32px', padding: '20px', backgroundColor: '#f4f4f5', borderRadius: '10px' }}>
          <h2 style={{ margin: '0', fontSize: '28px', textTransform: 'uppercase', letterSpacing: '3px', color: '#84cc16' }}>
            Membership Certificate
          </h2>
        </div>

        {/* Content */}
        <div style={{ marginBottom: '24px', lineHeight: '1.6', fontSize: '16px', textAlign: 'center' }}>
          <p style={{ margin: '14px 0' }}>This is to certify that</p>
          <h3 style={{ margin: '14px 0', fontSize: '26px', fontWeight: 'bold', color: '#18181b', textTransform: 'uppercase', borderBottom: '3px solid #84cc16', display: 'inline-block', paddingBottom: '8px' }}>
            {member?.name || 'Member'}
          </h3>
          <p style={{ margin: '14px 0' }}>has been enrolled in the</p>
          <h3 style={{ margin: '14px 0', fontSize: '22px', fontWeight: 'bold', color: '#84cc16' }}>
            {plan?.name || 'Membership Plan'}
          </h3>
        </div>

        {/* Subscription Details */}
        <div style={{ marginBottom: '24px', padding: '20px', backgroundColor: '#fafafa', borderRadius: '10px', border: '2px solid #e4e4e7' }}>
          <table style={{ width: '100%', fontSize: '14px', borderCollapse: 'separate', borderSpacing: '0 10px' }}>
            <tbody>
              <tr>
                <td style={{ padding: '8px', width: '40%', fontWeight: 'bold' }}>Subscription ID:</td>
                <td style={{ padding: '8px' }}>{subscription?.id?.slice(0, 8).toUpperCase() || 'N/A'}</td>
              </tr>
              <tr>
                <td style={{ padding: '8px', fontWeight: 'bold' }}>Valid From:</td>
                <td style={{ padding: '8px' }}>{formatDate(subscription?.start_date)}</td>
              </tr>
              <tr>
                <td style={{ padding: '8px', fontWeight: 'bold' }}>Valid Until:</td>
                <td style={{ padding: '8px' }}>{formatDate(subscription?.end_date)}</td>
              </tr>
              <tr>
                <td style={{ padding: '8px', fontWeight: 'bold' }}>Duration:</td>
                <td style={{ padding: '8px' }}>{plan?.duration_days || 'N/A'} Days</td>
              </tr>
              <tr>
                <td style={{ padding: '8px', fontWeight: 'bold' }}>Amount Paid:</td>
                <td style={{ padding: '8px', fontSize: '16px', fontWeight: 'bold', color: '#84cc16' }}>{formatCurrency(subscription?.amount_due || plan?.price || 0)}</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Footer */}
        <div style={{ marginTop: '32px', display: 'flex', justifyContent: 'space-between', paddingTop: '20px', borderTop: '2px solid #e4e4e7' }}>
          <div style={{ textAlign: 'center', width: '45%' }}>
            <div style={{ borderTop: '2px solid #18181b', paddingTop: '8px', marginTop: '28px' }}>
              <p style={{ margin: '0', fontSize: '13px', fontWeight: 'bold' }}>Authorized Signature</p>
            </div>
          </div>
          <div style={{ textAlign: 'center', width: '45%' }}>
            <div style={{ paddingTop: '8px', marginTop: '28px' }}>
              <p style={{ margin: '0', fontSize: '13px' }}>Issue Date</p>
              <p style={{ margin: '4px 0', fontSize: '14px', fontWeight: 'bold' }}>{formatDate(subscription?.start_date || new Date().toISOString())}</p>
            </div>
          </div>
        </div>

        {/* Bottom Note */}
        <div style={{ marginTop: '24px', textAlign: 'center', fontSize: '11px', color: '#71717a' }}>
          <p style={{ margin: '4px 0' }}>{company?.phone || ''} | {company?.email || ''}</p>
          <p style={{ margin: '4px 0' }}>{company?.website || ''}</p>
        </div>
      </div>

      <div className="receipt-a5" style={{
        width: '148mm',
        height: '210mm',
        padding: '10mm',
        margin: '0 auto',
        backgroundColor: 'white',
        fontFamily: 'Arial, sans-serif',
        border: '6px solid #84cc16',
        boxSizing: 'border-box'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          {company?.logo_url && (
            <img 
              src={`${process.env.REACT_APP_BACKEND_URL}${company.logo_url}`}
              alt="Company Logo" 
              crossOrigin="anonymous"
              style={{ maxHeight: '60px', maxWidth: '160px', margin: '0 auto 10px', display: 'block' }}
            />
          )}
          <h1 style={{ margin: '0', fontSize: '26px', fontWeight: 'bold', color: '#18181b' }}>{company?.name || 'Gym'}</h1>
          <p style={{ margin: '4px 0', fontSize: '11px', color: '#71717a' }}>{company?.address || ''}</p>
        </div>

        <div style={{ textAlign: 'center', marginBottom: '24px', padding: '16px', backgroundColor: '#f4f4f5', borderRadius: '8px' }}>
          <h2 style={{ margin: '0', fontSize: '20px', textTransform: 'uppercase', letterSpacing: '2px', color: '#84cc16' }}>
            Membership Certificate
          </h2>
        </div>

        <div style={{ marginBottom: '18px', lineHeight: '1.5', fontSize: '13px', textAlign: 'center' }}>
          <p style={{ margin: '10px 0' }}>This is to certify that</p>
          <h3 style={{ margin: '10px 0', fontSize: '20px', fontWeight: 'bold', color: '#18181b', textTransform: 'uppercase', borderBottom: '3px solid #84cc16', display: 'inline-block', paddingBottom: '6px' }}>
            {member?.name || 'Member'}
          </h3>
          <p style={{ margin: '10px 0' }}>has been enrolled in the</p>
          <h3 style={{ margin: '10px 0', fontSize: '18px', fontWeight: 'bold', color: '#84cc16' }}>
            {plan?.name || 'Membership Plan'}
          </h3>
        </div>

        <div style={{ marginBottom: '16px', padding: '16px', backgroundColor: '#fafafa', borderRadius: '8px', border: '2px solid #e4e4e7' }}>
          <table style={{ width: '100%', fontSize: '11px', borderCollapse: 'separate', borderSpacing: '0 8px' }}>
            <tbody>
              <tr>
                <td style={{ padding: '4px', width: '40%', fontWeight: 'bold' }}>Subscription ID:</td>
                <td style={{ padding: '4px' }}>{subscription?.id?.slice(0, 8).toUpperCase() || 'N/A'}</td>
              </tr>
              <tr>
                <td style={{ padding: '4px', fontWeight: 'bold' }}>Valid From:</td>
                <td style={{ padding: '4px' }}>{formatDate(subscription?.start_date)}</td>
              </tr>
              <tr>
                <td style={{ padding: '4px', fontWeight: 'bold' }}>Valid Until:</td>
                <td style={{ padding: '4px' }}>{formatDate(subscription?.end_date)}</td>
              </tr>
              <tr>
                <td style={{ padding: '4px', fontWeight: 'bold' }}>Duration:</td>
                <td style={{ padding: '4px' }}>{plan?.duration_days || 'N/A'} Days</td>
              </tr>
              <tr>
                <td style={{ padding: '4px', fontWeight: 'bold' }}>Amount Paid:</td>
                <td style={{ padding: '4px', fontSize: '13px', fontWeight: 'bold', color: '#84cc16' }}>{formatCurrency(subscription?.amount_due || plan?.price || 0)}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div style={{ marginTop: '16px', display: 'flex', justifyContent: 'space-between', paddingTop: '12px', borderTop: '2px solid #e4e4e7' }}>
          <div style={{ textAlign: 'center', width: '45%' }}>
            <div style={{ borderTop: '2px solid #18181b', paddingTop: '6px', marginTop: '20px' }}>
              <p style={{ margin: '0', fontSize: '11px', fontWeight: 'bold' }}>Authorized Signature</p>
            </div>
          </div>
          <div style={{ textAlign: 'center', width: '45%' }}>
            <div style={{ paddingTop: '6px', marginTop: '20px' }}>
              <p style={{ margin: '0', fontSize: '11px' }}>Issue Date</p>
              <p style={{ margin: '3px 0', fontSize: '12px', fontWeight: 'bold' }}>{formatDate(subscription?.start_date || new Date().toISOString())}</p>
            </div>
          </div>
        </div>

        <div style={{ marginTop: '16px', textAlign: 'center', fontSize: '10px', color: '#71717a' }}>
          <p style={{ margin: '3px 0' }}>{company?.phone || ''} | {company?.email || ''}</p>
          <p style={{ margin: '3px 0' }}>{company?.website || ''}</p>
        </div>
      </div>

      <div className="receipt-thermal" style={{
        width: '80mm',
        padding: '5mm',
        margin: '0 auto',
        backgroundColor: 'white',
        fontFamily: 'Courier, monospace',
        fontSize: '12px',
        boxSizing: 'border-box',
        border: '1px solid #e4e4e7'
      }}>
        <div style={{ textAlign: 'center', borderBottom: '1px dashed #000', paddingBottom: '8px', marginBottom: '8px' }}>
          <div style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '4px' }}>
            {company?.name || 'Gym'}
          </div>
          <div style={{ fontSize: '10px' }}>{company?.address || ''}</div>
          <div style={{ fontSize: '10px' }}>Ph: {company?.phone || ''}</div>
        </div>

        <div style={{ textAlign: 'center', marginBottom: '8px' }}>
          <div style={{ fontSize: '12px', fontWeight: 'bold' }}>Membership Certificate</div>
        </div>

        <div style={{ marginBottom: '8px', fontSize: '11px' }}>
          <div>ID: {subscription?.id?.slice(0,8).toUpperCase()}</div>
          <div>Member: {member?.name}</div>
          <div>Plan: {plan?.name}</div>
          <div>From: {formatDate(subscription?.start_date)}</div>
          <div>Until: {formatDate(subscription?.end_date)}</div>
        </div>

        <div style={{ borderTop: '1px dashed #000', paddingTop: '8px', marginTop: '8px', textAlign: 'center', fontSize: '10px' }}>
          <div>Powered by IronPulse Manager</div>
        </div>
      </div>
    </div>
  );
});

SubscriptionCertificate.displayName = 'SubscriptionCertificate';

export default SubscriptionCertificate;
